import React from 'react';

const MenuHero: React.FC = () => {
  return (
    <div className="relative">
      {/* Flex container for hero text and button */}
      <div className="max-w-6xl mx-auto w-full flex flex-col items-center justify-between">
        {/* Text Container: 75% width on md+ */}
        <div className="w-full md:w-3/4 text-center md:text-left max-w-4xl">
          <div className="font-charles text-maroon text-4xl md:text-6xl !leading-tight">
            Explore our menu filled with fresh seafood dishes, crafted with the
            flavors of Baja California.
          </div>
        </div>
        {/* Button Container: 25% width on md+; centered on mobile, right-aligned on md+ */}
        <div className="w-full md:w-1/3 flex justify-center self-end md:justify-end mt-4 md:mt-0">
          <a
            href="https://santaplaya-bucket.s3.us-west-2.amazonaws.com/Hand+Menu.pdf"
            target="_blank"
            rel="noopener noreferrer"
            download
            className="bg-sea text-white rounded-full py-2 px-6 md:py-3 md:px-8 font-prosto text-xs md:text-sm"
          >
            Download PDF Menu
          </a>
        </div>
      </div>

      <div className="mt-16">
        <img
          src="https://santaplaya-bucket.s3.amazonaws.com/fishTacoHero.webp"
          alt="Fish Taco Hero"
        />
      </div>

      <img
        className="absolute -left-[12.5%] top-[15%] w-[35vw]"
        src="https://santaplaya-bucket.s3.amazonaws.com/fish.webp"
        alt="Fish Accent"
      />
      <img
        className="absolute left-[12.5%] top-0 w-[8vw]"
        src="https://santaplaya-bucket.s3.amazonaws.com/bubbles_light.webp"
        alt="Bubbles Accent"
      />
      <img
        className="absolute right-[12.5%] top-0 w-[15vw]"
        src="https://santaplaya-bucket.s3.amazonaws.com/starfish.webp"
        alt="Starfish Accent"
      />
      <img
        className="absolute -right-[12.5%] top-1/4 w-[45vw] z-[-1]"
        src="https://santaplaya-bucket.s3.amazonaws.com/fish_school.webp"
        alt="Fish School Background"
      />
    </div>
  );
};

export default MenuHero;
